/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ComponentCompilerControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation componentCompilerControllerCompileComponent
   */
  static readonly ComponentCompilerControllerCompileComponentPath = '/component-compiler/compile-component/{componentDefinitionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compileComponent()` instead.
   *
   * This method doesn't expect any request body.
   */
  compileComponent$Response(params: {
    componentDefinitionId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentCompilerControllerService.ComponentCompilerControllerCompileComponentPath, 'get');
    if (params) {
      rb.path('componentDefinitionId', params.componentDefinitionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `compileComponent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compileComponent(params: {
    componentDefinitionId: string;
  }): Observable<void> {

    return this.compileComponent$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation componentCompilerControllerFindComponentCompilingProcess
   */
  static readonly ComponentCompilerControllerFindComponentCompilingProcessPath = '/component-compiler/component-compiling-process/{componentDefinitionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findComponentCompilingProcess()` instead.
   *
   * This method doesn't expect any request body.
   */
  findComponentCompilingProcess$Response(params: {
    componentDefinitionId: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentCompilerControllerService.ComponentCompilerControllerFindComponentCompilingProcessPath, 'get');
    if (params) {
      rb.path('componentDefinitionId', params.componentDefinitionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findComponentCompilingProcess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findComponentCompilingProcess(params: {
    componentDefinitionId: string;
  }): Observable<any> {

    return this.findComponentCompilingProcess$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation componentCompilerControllerDeleteDist
   */
  static readonly ComponentCompilerControllerDeleteDistPath = '/component-compiler/delete-dist/{componentDefinitionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDist()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDist$Response(params: {
    componentDefinitionId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentCompilerControllerService.ComponentCompilerControllerDeleteDistPath, 'delete');
    if (params) {
      rb.path('componentDefinitionId', params.componentDefinitionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteDist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDist(params: {
    componentDefinitionId: string;
  }): Observable<void> {

    return this.deleteDist$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
